"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTerritoryValueProvider = void 0;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const classifiers_1 = require("../../classifiers");
function useTerritoryValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (0, classifiers_1.buildPublicDataValueProvider)(Object.assign(Object.assign({ label: t('defaultClassifiers.territory') }, params), { classifierName: 'territory' }));
}
exports.useTerritoryValueProvider = useTerritoryValueProvider;
